import api from '../service/service.js'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      process: 0,
      status: 'เตรียมพร้อมแล้ว'
    }
  },
  methods: {
    backup_now () {
      this.status = 'กำลังประมวลผล'
      var l = setInterval(() => {
        this.process += 1
        if (this.process === 100) {
          clearInterval(l)
        }
      }, 100)
      api.backupData(
        result => {
          if (result.result === true) {
            this.status = 'ประมวลผลสำเร็จ'
            setTimeout(() => {
              this.alert_massage(
                'success',
                'Backup database',
                'Backup database successfully'
              )
              this.$store.state.isLoading = true
            }, 1500)
            setTimeout(() => {
              this.$store.state.isLoading = false
              this.process = 0
              this.status = 'เตรียมพร้อมแล้ว'
            }, 5000)
          } else {
            Swal.fire(
              'Backup Database Fail!',
              JSON.stringify(result.result),
              'warning'
            )
            setTimeout(() => {
              this.$store.state.isLoading = true
            }, 1500)
            setTimeout(() => {
              this.$store.state.isLoading = false
              this.process = 0
              this.status = 'เตรียมพร้อมแล้ว'
            }, 5000)
          }
          this.process = 100
          if (this.process === 100) {
            clearInterval(l)
          }
        },
        error => {
          console.log(JSON.stringify(error))
          Swal.fire('Backup Database Fail!', JSON.stringify(error), 'error')
          this.process = 100
          if (this.process === 100) {
            clearInterval(l)
          }
          setTimeout(() => {
            this.$store.state.isLoading = true
          }, 1500)
          setTimeout(() => {
            this.$store.state.isLoading = false
            this.process = 0
            this.status = 'เตรียมพร้อมแล้ว'
          }, 5000)
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/backup.js